import { render } from "./CollectionV2.vue?vue&type=template&id=4768a900&scoped=true"
import script from "./CollectionV2.vue?vue&type=script&lang=js"
export * from "./CollectionV2.vue?vue&type=script&lang=js"

import "./CollectionV2.vue?vue&type=style&index=0&id=4768a900&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4768a900"]])

export default __exports__